export const PROJECT_TITLE = "GMDB";

export const GET_MOVIE_DETAIL_BEGIN = "GET_MOVIE_BEGIN";
export const GET_MOVIE_DETAIL_SUCCESS = "GET_MOVIE_SUCCESS";
export const GET_MOVIE_DETAIL_FAIL = "GET_MOVIE_FAIL";

export const BASE_URL = "http://localhost:4000";
export const BASE_URL_USER = "http://localhost:4000/user";
export const BASE_URL_MOVIE = "http://localhost:4000/movie";
export const BASE_URL_REVIEW = "https://gmdb.gabatch13.my.id/review";
export const BASE_URL_SEARCH = "";
export const BASE_YOUTUBE_EMBED = "https://www.youtube.com/embed";
export const BASE_URL_TMDB_MOVIE = "https://api.themoviedb.org/3/movie/";

export const BASE_URL_MOVIE_NOWPLAYING =
  "https://api.themoviedb.org/3/movie/now_playing";
export const BASE_URL_MOVIE_IMG = "https://image.tmdb.org/t/p/original";

// export const API_KEY = process.env.REACT_APP_API_KEY;
export const API_KEY = `?api_key=${process.env.REACT_APP_API_KEY}`;

export const GET_REVIEW_BEGIN = "GET_REVIEW_BEGIN";
export const GET_REVIEW_SUCCESS = "GET_REVIEW_SUCCESS";
export const GET_REVIEW_FAIL = "GET_REVIEW_FAIL";

export const SUBMIT_REVIEW_BEGIN = "SUBMIT_REVIEW_BEGIN";
export const SUBMIT_REVIEW_SUCCESS = "SUBMIT_REVIEW_SUCCESS";
export const SUBMIT_REVIEW_FAIL = "SUBMIT_REVIEW_FAIL";

export const CHANGE_REVIEW_BEGIN = "CHANGE_REVIEW_BEGIN";
export const CHANGE_REVIEW_SUCCESS = "CHANGE_REVIEW_SUCCESS";
export const CHANGE_REVIEW_FAIL = "CHANGE_REVIEW_FAIL";

export const GET_MOVIES_BEGIN = "GET_MOVIES_BEGIN";
export const GET_MOVIES_SUCCESS = "GET_MOVIES_SUCCESS";
export const GET_MOVIES_FAIL = "GET_MOVIES_FAIL";

export const GET_MOVIES_BANNER_BEGIN = "GET_MOVIES_BANNER_BEGIN";
export const GET_MOVIES_BANNER_SUCCESS = "GET_MOVIES_BANNER_SUCCESS";
export const GET_MOVIES_BANNER_FAIL = "GET_MOVIES_BANNER_FAIL";

export const SEARCH_BEGIN = "SEARCH_BEGIN";
export const SEARCH_SUCCESS = "SEARCH_SUCCESS";
export const SEARCH_FAIL = "SEARCH_FAIL";
export const CLEAR = "CLEAR";

export const BASE_URL_GMDB = "https://gmdb.gabatch13.my.id/";
export const BASE_URL_SETROLE_GMDB = "https://gmdb.gabatch13.my.id/setrole/";
export const BASE_URL_USER_GMDB = "https://gmdb.gabatch13.my.id/user/";
export const BASE_URL_ME_GMDB = "https://gmdb.gabatch13.my.id/user/me";
export const BASE_URL_SIGNUP_GMDB = "https://gmdb.gabatch13.my.id/user/signup/";
export const BASE_URL_SIGNIN_GMDB = "https://gmdb.gabatch13.my.id/user/signin/";
export const BASE_URL_MOVIE_GMDB = "https://gmdb.gabatch13.my.id/movie";
export const BASE_URL_REVIEW_GMDB =
  "https://gmdb.gabatch13.my.id/review/movie/";
export const BASE_URL_SEARCH_TITLE_GMDB =
  "https://gmdb.gabatch13.my.id/movie/title/";
export const BASE_URL_SEARCH_GMDB = "";
export const BASE_URL_ACTOR_GMDB = "https://gmdb.gabatch13.my.id/actor/";

export const GET_USER_BEGIN = "GET_USER_BEGIN";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAIL = "GET_USER_FAIL";

export const GET_ACTOR_BEGIN = "GET_ACTOR_BEGIN";
export const GET_ACTOR_SUCCESS = "GET_ACTOR_SUCCESS";
export const GET_ACTOR_FAIL = "GET_ACTOR_FAIL";
